import { useIonAlert } from '@ionic/react';
import { useCallback } from 'react';

type PresentConfirmationAlert = () => void;
type ConfirmationAction = () => void;
interface ConfirmActionAlertOptions {
  message: string;
  confirmationAction: ConfirmationAction;
  header?: string;
  confirmText?: string;
  cancelText?: string;
  isDestructive?: boolean;
  onCancel?: () => void;
}
type ConfirmActionAlert = (options: ConfirmActionAlertOptions) => () => void;

export const useConfirmActionAlert = (): ConfirmActionAlert => {
  const [present] = useIonAlert();

  const confirmationActionAlert = useCallback(
    (options: ConfirmActionAlertOptions): PresentConfirmationAlert => {
      const {
        message,
        confirmationAction,
        header,
        confirmText,
        cancelText,
        isDestructive,
        onCancel,
      } = options;

      return () => {
        present({
          header,
          message,
          buttons: [
            {
              text: cancelText ?? 'Cancel',
              role: 'cancel',
              handler: onCancel,
            },
            {
              text: confirmText ?? 'Confirm',
              handler: confirmationAction,
              role: isDestructive ? 'destructive' : undefined,
            },
          ],
        });
      };
    },
    [present]
  );

  return confirmationActionAlert;
};
